// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"55536f8a","453":"04771f90"}[chunkId] + ".chunk.js";
};